import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SalesFunnel from './components/SalesFunnel';
import ScrollNavbar from './components/ScrollNavbar';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollNavbar />
        <Routes>
          <Route path="/" element={<SalesFunnel />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;